import { render } from "./UserAgent.vue?vue&type=template&id=df77dd8c"
import script from "./UserAgent.vue?vue&type=script&lang=js"
export * from "./UserAgent.vue?vue&type=script&lang=js"

import exportComponent from "/ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__